import React, { Component } from "react";
import Cookies from "universal-cookie";
import moment from "moment";
import { Buffer } from "buffer";

import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";

import { Button, Col, Form, Row, Modal, DatePicker, Input, Upload, Select } from "antd";
import { SaveOutlined, UploadOutlined } from "@ant-design/icons";

import { InsertStockCheryStates } from "./types/InsertStockCheryTypes";
import { stockOtodisService } from "../../services/otodisApi/StockOtodisService";
// import { docUploadApiService } from "../../services/otodis/DocUploadApiService";

export interface InsertStockDayaProps {}

class InsertStockDaya extends Component<InsertStockDayaProps & any, InsertStockCheryStates> {
  private readonly initState!: InsertStockCheryStates;
  private token = new Cookies().get("_t");

  constructor(props: (InsertStockDayaProps & any) | any) {
    super(props);

    const finalDealerCode = props.match.params.dealerCode.replace(/-/g, "#");

    this.initState = {
      submitting: false,
      loading: false,

      dealerCode: finalDealerCode,
      user: "",
      optAction: "MANUAL_HK",

      manualInvoiceNumber: "",
      manualInvoiceFile: [],
      manualInvoiceDate: moment().format("YYYY-MM-DD"),
    };
    this.state = { ...this.initState };
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const token = cookies.get("_t");
    if (token) {
      const user = JSON.parse(Buffer.from(cookies.get("_u"), "base64").toString());
      await this.promisedSetState({
        user: user,
      });
    }
  }

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      dealerCode: data.value,
    });
  };

  onFieldChange = <T extends keyof Pick<any, "manualInvoiceNumber" | "manualInvoiceFile" | "manualInvoiceDate" | "optAction">>(target: T, value: any) => {
    const currentState: any = { ...this.state };

    switch (target) {
      case "manualInvoiceNumber":
        currentState.manualInvoiceNumber = value;
        break;
      case "manualInvoiceFile":
        currentState.manualInvoiceFile = value;
        break;
      case "manualInvoiceDate":
        currentState.manualInvoiceDate = value;
        break;
      case "optAction":
        currentState.optAction = value;
        break;
    }
    this.setState({
      ...currentState,
    });
  };

  beforeUploadFile = (file: any) => {
    const isPdf = file.type === "application/pdf";
    if (!isPdf) {
      Modal.error({
        title: "Proses Gagal",
        content: "Format File Bukan PDF",
      });
    }
    if (isPdf) {
      this.setState({
        manualInvoiceFile: file,
      });
    } else {
      this.setState({
        manualInvoiceFile: [],
      });
    }
    return false;
  };

  buttonInsertStock = async () => {
    const currentState: any = { ...this.state };

    if (!currentState.dealerCode) {
      Modal.error({ title: "Error", content: "Invalid Dealer" });
      return;
    }
    if (!currentState.dateStock) {
      Modal.error({ title: "Error", content: "Invalid Tanggal Surat Jalan " });
      return;
    }

    this.setState({ submitting: true });

    const data_post = {
      dealer_code: currentState.dealerCode,
      date: currentState.dateStock,
    };

    try {
      stockOtodisService.setToken(this.token);
      await stockOtodisService.saveStockMotora(data_post).then(async (result: any) => {
        Modal.success({
          title: "Proses Sukses",
          content: result.data.message,
        });
        await this.promisedSetState({
          submitting: false,
        });
      });
    } catch (e: any) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda : " + e,
      });
      await this.promisedSetState({
        submitting: false,
      });
    }
  };

  buttonManualInvoice = async () => {
    // const currentState: any = { ...this.state };

    Modal.error({ title: "Error", content: "Under Maintenance" });
    return;

    // if (!currentState.dealerCode) {
    //   Modal.error({ title: "Error", content: "Invalid Dealer" });
    //   return;
    // }
    // if (!currentState.manualInvoiceNumber) {
    //   Modal.error({ title: "Error", content: "Invalid No Invoice HK" });
    //   return;
    // }
    // if (!currentState.manualInvoiceDate) {
    //   Modal.error({ title: "Error", content: "Invalid Date" });
    //   return;
    // }
    // if (!currentState.manualInvoiceFile) {
    //   Modal.error({ title: "Error", content: "Invalid File Empty" });
    //   return;
    // }

    // this.setState({ submitting: true });

    // // docUploadApiService.setToken(this.token);

    // const formData = new FormData();
    // formData.append("dealer_code", this.state.dealerCode);
    // formData.append("invoice_number", this.state.manualInvoiceNumber);
    // formData.append("date", this.state.manualInvoiceDate);
    // formData.append("file_invoice_stock", this.state.manualInvoiceFile);

    // try {
    //   // await docUploadApiService.uploadStockInvoice(formData);

    //   await docUploadApiService.uploadStockInvoice(formData).then(async (result: any) => {
    //     Modal.success({
    //       title: "Proses Sukses",
    //       content: result.data.message,
    //     });
    //     await this.promisedSetState({
    //       submitting: false,
    //     });
    //   });
    // } catch (e: any) {
    //   Modal.error({
    //     title: "Proses Gagal",
    //     content: "Server Menolak Inputan Anda : " + e,
    //   });
    //   await this.promisedSetState({
    //     submitting: false,
    //   });
    // }
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Stock`}
          breadcrumbMenu={`Stock Chery`}
          defaultSelectedKeys={["m-stock-chery"]}
          defaultOpenKeys={["sm-stock", "sm-sm-purchase"]}
        >
          <Form layout={"vertical"}>
            <Row>
              <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                <Form.Item style={{ paddingRight: 10 }}>
                  <i className={`text-small-grey-nopadding`}>
                    Pilih Aksi <span style={{ color: "red" }}>*</span>{" "}
                  </i>
                  <Select value={this.state.optAction} onChange={(value: string) => this.onFieldChange("optAction", value)} disabled>
                    <Select.Option value="MANUAL_HK">Upload File Invoice Chery</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              {this.state.optAction === "MANUAL_HK" && (
                <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                  <Row>
                    <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                      <Form.Item style={{ paddingRight: 10 }}>
                        <i className={`text-small-grey-nopadding`}>
                          No Invoice <span style={{ color: "red" }}>*</span>{" "}
                        </i>
                        <Input type="text" value={this.state.manualInvoiceNumber} placeholder="Nomor Invoice" onChange={(event) => this.onFieldChange("manualInvoiceNumber", event.target.value)} />
                      </Form.Item>
                    </Col>
                    <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                      <Form.Item style={{ paddingRight: 10 }}>
                        <i className={`text-small-grey-nopadding`}>
                          Tanggal <span style={{ color: "red" }}>*</span>{" "}
                        </i>
                        <DatePicker
                          value={moment(this.state.manualInvoiceDate, "YYYY-MM-DD")}
                          format={"YYYY-MM-DD"}
                          style={{ width: "100%" }}
                          onChange={(date, dateString) => this.onFieldChange("manualInvoiceDate", dateString)}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item>
                    <i className={`text-small-grey-nopadding`}>
                      File Invoice <span style={{ color: "red" }}>*</span>{" "}
                    </i>
                    <br />
                    <Upload maxCount={1} beforeUpload={this.beforeUploadFile} showUploadList={false}>
                      <Button icon={<UploadOutlined />}>Select File</Button>
                    </Upload>
                  </Form.Item>
                  <Button type={"primary"} icon={<SaveOutlined />} loading={this.state.submitting} onClick={this.buttonManualInvoice}>
                    Upload File
                  </Button>
                </Col>
              )}
            </Row>
          </Form>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(InsertStockDaya), 51);
